import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from './components/Home.vue';

export default new VueRouter({
  routes: [
  { path: '/',
    children: [
      { path: '', component: Home, name: 'home' }
    ]
  },
  { path: '*', component: Home } // Not found
  ]

  /*
   * NOTE! VueRouter "history" mode DOESN'T works for Cordova builds,
   * it is only to be used only for websites.
   *
   * If you decide to go with "history" mode, please also open /config/index.js
   * and set "build.publicPath" to something other than an empty string.
   * Example: '/' instead of current ''
   *
   * If switching back to default "hash" mode, don't forget to set the
   * build publicPath back to '' so Cordova builds work again.
   */

  /*
  routes: [
    { path: '/', component: Hello }
  ]
   */
})

// export default router



// WEBPACK FOOTER //
// ./src/router.js